import CenterFocusStrongRoundedIcon from '@mui/icons-material/CenterFocusStrongRounded';
import CenterFocusWeakRoundedIcon from '@mui/icons-material/CenterFocusWeakRounded';
import { smallButtonClasses } from '@wt/shared/components/buttons/SmallButton';

export function CenterButton({
  isCentered,
  onClick,
  margin,
}: {
  isCentered: boolean;
  onClick: () => void;
  margin: string;
}) {
  return (
    <div
      onClick={onClick}
      className={`pointer-events-auto ${margin} ${smallButtonClasses}`}
    >
      {isCentered ? (
        <CenterFocusWeakRoundedIcon htmlColor={'black'} />
      ) : (
        <CenterFocusStrongRoundedIcon htmlColor={'black'} />
      )}
    </div>
  );
}